import { Grid, Card } from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const Wrapper = lib.styled.div`
  position: relative;
  [class*='MuiCard-root-'] {
    box-shadow: none!important;
    overflow: visible!important;
    margin: 10px;
    margin-top: 5px;
  }

  .volumeButton{
    position: absolute;
    top: -38px;
    left: 70px;
    z-index: 9;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    .icon {
      div {
        height: 20px;

        path {
          background-color: ${colors.black};
          opacity: 0.7;
        }
      }
    }
  }
  
  .deviceManagerBtn{
    position: absolute;
    top: -38px;
    left: 63px;
    z-index: 9;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    .buttons-container {
      display: flex; 
      flex-direction: row;
    }
    
    .MuiButton-root {
      min-width: 20px !important;
    }
  }
`;

export const BtnHangUp = lib.styled.button`
  cursor:  ${props => (!props.finished ? 'pointer' : 'default')}!important;
  .red {
    background-color: ${props =>
      !props.finished ? colors.red04 : colors.lightGray06}!important;
  }
`;

export const Container = lib.styled(Card)`
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 5px;
  border-radius: 10px!important;

  .icon {
    color: ${colors.white}!important;
    padding: 5px;
  }
  .icon-blue {
    color: #00aeef!important;
    padding: 5px;
  }
`;

export const ActiveSession = lib.styled.div`
  width: 100%;
  height: 68px;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 999;
`;

export const GroupButton = lib.styled.div`
  display: flex;
  background-color: #3e3d3d;
  border-radius: 5px;
  margin-left: 5px;

  .btn-handle {
    color: #FFF;
    font-size: 10px;
    width: 100px;
    min-width: 30px!important;
    height: 30px;
  }

  .btn {
    color: #FFF;
    width: 20px;
    min-width: 20px!important;
    height: 30px;
  }
`;

export const Root = lib.styled.div`
  display: flex;
  position: absolute;
  width: 295px;
  top: -40px;
  left: 104px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  height: 30px;
  z-index: 99999;
  span {
    /* color: #FFF; */
    font-size: 11px;
  }

  .sliderRoot {
    width: 80%;

    [class*='MuiSlider-track-'] {
      background-color: ${props =>
        props.headerColor ? colors.white : colors.black}!important;
    }
    [class*='MuiSlider-thumb-'] {
      background-color: ${props =>
        props.headerColor ? colors.white : colors.black}!important;
    }

    &.MuiSlider-root {
      color: ${colors.green05}!important;
    }
  }
`;

export const TransferArea = lib.styled(Grid)`
  display: flex;
  /* z-index: 99999999; */
  /* position: absolute; */
  margin-top: 10px;
  flex-direction: row;
  background-color: ${colors.lightGreen};
  min-height: 47px;
  width: 100%;
  box-shadow: 0 1px 6px 0 rgba(32, 33, 36, .28);

  input {
    border-radius: 10px;
    background-color: transparent;
    outline: 0;
    border: 0;
    width: 100%;
    display: flex;
    font-size: ${props => (props.qty > 0 ? 20 : 13)}px;
    flex: 1;
    max-height: 45px;
    min-height: 45px;
    padding-left: 15px;
    padding-right: 15px;
  }

  .divider {
    height: 1px;
    width: 100%;
    background-color: ${colors.lightGreen02};
  }

  .actions-transfer {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: flex-end;
    min-height: 40px;

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      border: 0px;
      cursor: pointer;
      width: 90px;
      height: 25px;
      border: 1px solid ${colors.lightGray06};
      border-radius: 30px;
      margin-right: 5px;

      &:last-child {
        margin-right: 15px;
      }

      .icon-transfer {
        margin-right: 5px;
        div {
          height: 15px;
        }
        svg {
          width: 20px;
          height: 15px;
        }
        path {
          fill: ${colors.green04};
        }
      }

      .icon-conference {
        margin-right: 5px;
        div {
          height: 15px;
        }
        svg {
          width: 12px;
          height: 12px;
        }
        path {
          fill: ${colors.green04};
        }
      }

      span {
        font-size: 11px;
        color: ${colors.darkGray01};
      }
    }
  }

  .icon {
    color: #6cf56c;
    padding-left: 5px;
  }
`;

export const CallItem = lib.styled.div`
  display: flex;
  flex-direction: column;
  background-color: colors.white02;
  box-shadow: 0 1px 6px 0 rgba(32, 33, 36, .28);
  position: relative;
  padding: 3px;
  border: 1px solid ${props =>
    props.active ? colors.red04 : colors.lightGray06};
  border-radius: 10px;

  .icon-full {
    position: absolute;
    bottom: 0px;
    right: 0px;
    color: #00aeef!important;
    cursor: pointer;
    font-size: 25px;
  }
`;

export const FirstRow = lib.styled.div`
  display: flex;
  flex: 1;
  min-height: 58px;
  max-height: 58px;
  align-items: flex-start;
  justify-content: space-between;

  .left {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin-left: 8px;
    margin-top: 4px;

    .informations {
      display: flex;
      flex-direction: row;
      align-items: center;
      //margin-left: 8px;
      //margin-top: 4px;
      // a {
      //   color: ${colors.black};
      //   text-decoration: none;
      // };
      .space {
        margin-left: 5px;
        font-weight: normal!important;
      }
      .user-info {
        font-size: 16px;
        font-weight: 500;
        //color: ${colors.black};
        // &:first-child {
        //   font-weight: 500;
        // }
      }
    }
  }

  .rightGroup {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
  
    div:first-child {
      margin-top: -4px;
      margin-right: 2px;
    }
  }

  .right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    padding-right: 8px;
    padding-top: 8px;

    .timer {
      color: ${colors.lightBlue}!important;
      font-size: 13px!important;
      font-weight: 600;
    }
  }
`;

export const SecondRow = lib.styled.div`
  display: flex;
  flex: 1;
  min-height: 38px;
  max-height: 38px;
  background-color: ${colors.lightBlue02};
  border-bottom-left-radius: ${props => (!props.isExtendedCard ? '10px' : 0)};
  border-bottom-right-radius: ${props => (!props.isExtendedCard ? '10px' : 0)};

  .action-btn {
    background-color: ${colors.white};
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    /* margin-top: ${props => (props.isExtendedCard ? '-10px' : 0)};
    position: ${props => (props.isExtendedCard ? 'relative' : 'absolute')}; */
    margin-top: -10px;
    position: relative;
    border: 0;
    outline:none;
    cursor: pointer;
    bottom: 10px;

    div {
      width: 42px;
      height: 42px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .icon-transfer {
      font-size: 20px;
      svg {
        width: 20px;
        height: 20px;
      }
      path {
        fill: ${colors.white};
      }
    }
    .icon-call {
      font-size: 20px;
      svg {
        width: 25px;
        height: 20px;
      }
      path {
        fill: ${colors.white};
      }
    }
    .icon-conference {
      font-size: 28px;
      width: 70px;

      path {
        fill: ${colors.white};
      }
    }

    .green {
      background-color: #00AEEF;
    }
    .red {
      background-color: ${colors.red04};
    }
  }

  .action-one {
    /* right: ${props => (!props.isExtendedCard ? '65px' : '20px')}; */
    top: -6px;
    right: 20px;
  }

  .action-two {
    top: -6px;
    right: 10px;
  }

  .actions-buttons {
    display: flex
    flex: 1;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    min-width: 167px;

    .dtmfBox {
      display: flex;
      align-items: center;
      justify-content: center;

      .dtmfBtn {
        border-bottom-right-radius: 50%;
        border-top-right-radius: 50%;
      }

      .dtmfInput {
        border-radius: 30px;
        width: 100px;
        height: 25px;
        border-bottom-left-radius: 0px;
        border-top-left-radius: 0px;
        background-color: ${colors.lightGray10};

        &:before {
          border-bottom: 0px!important;
        }
        &:after {
          border-bottom: 0px!important;
        }
      }
    }

    button {
      margin-left: 7px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 25px;
      height: 25px;
      border-radius: 50%;
      background-color: ${colors.white};
      padding: 0px;
      border: 0;
      outline:none;
      cursor: pointer;
      opacity: ${props => (props.answered ? 1 : 0.7)};

      .icon-btn {
        font-size: 15px!important;
        color: ${colors.lightBlue03}!important;

        div {
          display: flex;
          height: fit-content;
        }
      }

      .icon-btn-conf {
        width: 17px;
        margin-top: -1px;
      }

      .dial-btn {
        font-size: 15px!important;
        color: ${colors.lightBlue03}!important;
      }
      .dial-btn-active {
        font-size: 15px!important;
        color: ${colors.green05}!important;
      }
    }
  }
`;

export const StatusText = lib.styled.p`
  font-size: 13px;
  color: ${colors.black};
  margin: -1px 0 0 0;
  text-align: center;
`;
